import { ModelBasedVisual } from "../../../visuals/ModelBasedVisual";
import { BaseAgent } from "./BaseAgent";

export class HumanAgent extends BaseAgent {
  mbv: ModelBasedVisual;
  constructor(visual: ModelBasedVisual) {
    super(visual);
    this.mbv = visual;
    this.addState('Walk', async () => {
      this.mbv.animator.walk();
      return true;
    }, async () => {
      this.mbv.animator.stop();
    });
  }
}